export var ReportArea;
(function (ReportArea) {
    ReportArea[ReportArea["PlayerHours"] = 1] = "PlayerHours";
    ReportArea[ReportArea["PlayerCount"] = 2] = "PlayerCount";
    ReportArea[ReportArea["UsageHours"] = 3] = "UsageHours";
    ReportArea[ReportArea["EUH"] = 4] = "EUH";
    ReportArea[ReportArea["MachineMaintenanceHours"] = 5] = "MachineMaintenanceHours";
    ReportArea[ReportArea["MachineMaintenanceSessions"] = 6] = "MachineMaintenanceSessions";
    ReportArea[ReportArea["Heatmap"] = 7] = "Heatmap";
    ReportArea[ReportArea["HighestParticipationDay"] = 8] = "HighestParticipationDay";
    ReportArea[ReportArea["LowestParticipationDay"] = 9] = "LowestParticipationDay";
    ReportArea[ReportArea["Weekdays"] = 10] = "Weekdays";
    ReportArea[ReportArea["Weekends"] = 11] = "Weekends";
    ReportArea[ReportArea["FieldRanking"] = 12] = "FieldRanking";
})(ReportArea || (ReportArea = {}));
//# sourceMappingURL=reportArea.enum.js.map